import { useAuth } from "@/context/auth-context.tsx";
import type React from "react";
import { useState } from "react";
import PinPage from "./pin";
import SignUpQuestionPage from "./question";
import VerifyEmailPage from "./VerifyEmailPage";
import { useVerifyAccountStep } from "./useVerifyAccountStep";
import { VerifyAccountStepProvider } from "./VerifyAccountStepContext.tsx";
import {
	type VerifyAccountStep,
	getVerifyAccountInitialStep,
} from "./verifyAccountSteps";
import VerifyPhonePromptPage from "./VerifyPhonePromptPage";
import TelCode from "./telCode";
import { Navigate } from "@tanstack/react-router";
import SignUpBusinessDetailsPage from "./SignUpBusinessDetailsPage";

const stepToComponent: Record<VerifyAccountStep, () => React.ReactElement> = {
	pin: () => <PinPage />,
	question: () => <SignUpQuestionPage />,
	verify_phone: () => <VerifyPhonePromptPage />,
	verify_phone_code: () => <TelCode />,
	verify_email: () => <VerifyEmailPage />,
	business_details: () => <SignUpBusinessDetailsPage />,
};

export default function VerifyAccountPage() {
	const { user } = useAuth();
	const [initialStep] = useState(() => {
		return getVerifyAccountInitialStep(user);
	});

	if (!initialStep) {
		return <Navigate to="/main/home" replace />;
	}

	return (
		<VerifyAccountStepProvider initialStepFromState={initialStep}>
			<VerifyAccountContent />
		</VerifyAccountStepProvider>
	);
}

function VerifyAccountContent() {
	const { step } = useVerifyAccountStep();

	const Component = stepToComponent[step];
	return Component();
}
